import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _dec4, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withWidth, { isWidthUp, WithWidthProps } from 'muiCompat/withWidth';
import { convertToRaw, EditorState, Modifier } from 'draft-js';
import { stateFromHTML } from 'draft-js-import-html';
import { createEditorState, NOT_HANDLED } from 'medium-draft';
import objectHash from 'object-hash';
import mediumDraftStyles from 'medium-draft/dist/medium-draft.css';
import AppContext from '../../../context';
import * as courseDetailsActions from '../../../actions/courseDetails';
import * as lessonDetailsActions from '../../../actions/lessonDetails';
import { convertRichEditorContentToHtml, convertFromDraftToPlain, getImagesFromDraftJS } from '../../../helpers';
import isMobileUserAgent from '../../../helpers/checkMobileUserAgent';
import isLoggedIn from '../../../helpers/checkAuth';
import Attachments from '../Attachments/Attachments';
import EmbeddedAttachments from '../EmbeddedAttachments/EmbeddedAttachments';
import LessonSources from '../LessonSources/LessonSources';
import s from './Text.scss';
import convertImages from './convertImages';
import decorators from './decorators';
import LessonTextContent from './LessonTextContent';
import messages from '../lessonDetailsMessages';
import intlPropTypes from '../../../constants/intlPropTypes';
var Text = (_dec = withWidth(), _dec2 = withStyles(s), _dec3 = withStyles(mediumDraftStyles), _dec4 = connect(function (state) {
  return {
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    course: state.courseDetails.course,
    updatingTextNotes: state.lessonDetails.updatingTextNotes,
    isNotesShown: state.lessonDetails.isNotesShown,
    loadingTextNotes: state.lessonDetails.loadingTextNotes,
    textNotes: state.lessonDetails.textNotes,
    offline: state.online.offline
  };
}, function (dispatch) {
  return bindActionCreators({
    getLessonTextNotes: lessonDetailsActions.getLessonTextNotes,
    updateState: lessonDetailsActions.updateState,
    getCourseBySlug: courseDetailsActions.getCourseBySlug
  }, dispatch);
}), _dec(_class = injectIntl(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Text, _React$Component);
  var _super = _createSuper(Text);
  function Text(props, context) {
    var _this;
    _classCallCheck(this, Text);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "previousTop", 0);
    // componentWillReceiveProps(nextProps) {
    //   if (_.get(this, 'props.lesson._id') !== _.get(nextProps, 'lesson._id')) {
    //     const { content, sources } = nextProps.lesson;
    //
    //     const newSources = _.cloneDeep(sources);
    //     const newContent = _.cloneDeep(content);
    //
    //     if (isLoggedIn(nextProps.auth)) {
    //       _.each(nextProps.textNotes, ({ offset, length, blockKey }) => {
    //         const blockIndex = _.findIndex(content.blocks, { key: blockKey });
    //         if (blockIndex !== -1) {
    //           newContent.blocks[blockIndex].inlineStyleRanges.push({
    //             style: 'HIGHLIGHT',
    //             offset,
    //             length,
    //           });
    //         }
    //       });
    //     }
    //
    //     const editorState = createEditorState(newContent);
    //     const editorStateSources = createEditorState(newSources);
    //     const editorStateContentSources = editorStateSources && editorStateSources.getCurrentContent();
    //     const isSourcesExist = editorStateContentSources && editorStateContentSources.hasText() && !!editorStateContentSources.getPlainText().trim().length;
    //
    //     this.setState({
    //       editorState,
    //       sourcesHTML: stateToHTML(editorStateContentSources),
    //       isSourcesExist,
    //     });
    //
    //     if (document && document.querySelector('#lesson-content')) {
    //       document.querySelector('#lesson-content').scrollTop = 0;
    //     }
    //   }
    // }
    _defineProperty(_assertThisInitialized(_this), "onContentScroll", function (_ref) {
      var target = _ref.target;
      var _this$props = _this.props,
        lesson = _this$props.lesson,
        complete = _this$props.complete;
      var contentScrolledPercent = _this.state.contentScrolledPercent;
      function getHeight(D) {
        return Math.max(D.scrollHeight, D.offsetHeight, D.clientHeight);
      }
      var newContentScrolledPercent = (target.scrollTop + target.offsetHeight) / getHeight(target);
      if (newContentScrolledPercent < contentScrolledPercent) {
        return;
      }
      _this.setStateDebounced({
        contentScrolledPercent: newContentScrolledPercent
      });
      if (newContentScrolledPercent > 0.9 && !lesson.isCompleted) {
        complete();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onEditorChange", function (editorState, callback) {
      var rerenderEditor = _this.state.rerenderEditor;
      var newEditorPlainText = convertFromDraftToPlain(editorState, ' ');
      var oldEditorPlainText = convertFromDraftToPlain(_this.state.editorState, ' ');
      if (newEditorPlainText !== oldEditorPlainText) {
        return _this.setState({
          rerenderEditor: !rerenderEditor
        }, function () {
          if (callback) {
            callback();
          }
        });
      }
      _this.setState({
        editorState: editorState
      }, function () {
        if (callback) {
          callback();
        }
      });
      return _this.updateTextNotesWithDebounce(editorState);
    });
    _defineProperty(_assertThisInitialized(_this), "onEditorDoubleClick", function (e) {
      if (e.pageY > _this.MIN_PAGE_Y_HIGHTLIGHT) {
        document.getElementById('lesson-content').scrollTop += 60; // pageY + MIN_PAGE_Y_HIGHTLIGHT -100;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getCssValueFromProp", function (prop) {
      return parseInt(prop.slice(0, prop.indexOf('.')), 10);
    });
    _defineProperty(_assertThisInitialized(_this), "handleScrollEventOnMobile", function () {
      var textEl = document.querySelector('#lesson-content');
      if (!textEl) {
        return;
      }
      if (textEl.clientHeight !== textEl.scrollHeight) {
        return;
      }
      var _this$props2 = _this.props,
        lesson = _this$props2.lesson,
        complete = _this$props2.complete;
      var contentScrolledPercent = _this.state.contentScrolledPercent;
      var h = document.documentElement;
      var b = document.body;
      var st = 'scrollTop';
      var sh = 'scrollHeight';
      var newContentScrolledPercent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight);
      if (newContentScrolledPercent < contentScrolledPercent) {
        return;
      }
      _this.setStateDebounced({
        contentScrolledPercent: newContentScrolledPercent
      });
      if (newContentScrolledPercent > 0.9 && !lesson.isCompleted) {
        complete();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "checkAndUpdateHighlightBtnPosition", function () {
      var d = document.getElementsByClassName('md-editor-toolbar--isopen');
      if (d.length) {
        _this.updateElement(d[0]);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateElement", function (el) {
      var currentTop = _this.getCssValueFromProp(el.style.top); // parseInt(top.slice(0, top.indexOf('.')))

      if (_this.previousTop !== currentTop) {
        // move element lower
        el.style.removeProperty('top');
        el.style.top = "".concat(currentTop + 90, "px"); // eslint-disable-line no-param-reassign

        var width = _this.getCssValueFromProp(el.style.width);
        // Check and move if element gonna outside the screen
        if (_this.getCssValueFromProp(el.style.left) < 0.35 * width) {
          el.style.removeProperty('margin-left');
          el.style['margin-left'] = "".concat(width / 3, "px"); // eslint-disable-line no-param-reassign
          el.classList.add(s.mdArrowLeft);
        } else {
          el.style.removeProperty('margin-left');
          el.classList.remove(s.mdArrowLeft);
          el.style['margin-left'] = "0"; // eslint-disable-line no-param-reassign
        }

        if (el.style.top !== "".concat(_this.previousTop, "px")) {
          _this.forceUpdate();
        }
        _this.previousTop = currentTop + 90;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateTextNotes", function (editorState) {
      var _this$props3 = _this.props,
        lesson = _this$props3.lesson,
        textNotes = _this$props3.textNotes,
        getLessonTextNotes = _this$props3.getLessonTextNotes,
        courseId = _this$props3.course._id,
        updateState = _this$props3.updateState;
      var isNotesShown = _this.props.isNotesShown;
      if (!isNotesShown || !courseId) {
        return false;
      }
      var _convertToRaw = convertToRaw(editorState.getCurrentContent()),
        blocks = _convertToRaw.blocks;
      var highlights = [];
      _.each(blocks, function (block) {
        var inlineStyleRanges = _.filter(block.inlineStyleRanges, function (inlineStyleRangesItem) {
          return inlineStyleRangesItem.style === 'HIGHLIGHT';
        });
        if (inlineStyleRanges && inlineStyleRanges.length) {
          _.each(inlineStyleRanges, function (inlineStyleRangesItem) {
            var offset = inlineStyleRangesItem.offset,
              length = inlineStyleRangesItem.length;
            var text = block.text.substr(offset, length);
            var order = _.get(_.find(textNotes, {
              blockKey: block.key,
              text: text,
              offset: offset,
              length: length
            }), 'order');
            if (!_.isNumber(order)) {
              var max = _.max(_.map(textNotes, 'order'));
              order = _.isNumber(max) ? max + 1 : 0;
            }
            highlights.push({
              offset: offset,
              length: length,
              text: text,
              blockKey: block.key,
              order: order
            });
          });
        }
      });
      if (objectHash(highlights) === objectHash(_.map(textNotes, function (textNote) {
        return _.omit(textNote, ['_id']);
      }))) {
        return false;
      }
      updateState('updatingTextNotes', true);
      return _this.context.fetch("/api/courses/".concat(courseId, "/text-notes/").concat(lesson._id), {
        method: 'PUT',
        body: JSON.stringify(highlights)
      }).then(function (res) {
        updateState('updatingTextNotes', false);
        if (res.ok) {
          getLessonTextNotes(courseId, lesson._id);
        }
      })["catch"](function (error) {
        console.error(error);
        updateState('updatingTextNotes', false);
      });
    });
    /*  Uncomment this function and add to the onTouchStart in element to disable
      default "Edit" toolbar on IOS. Working bad on android.
       lastTappedTimestamp = Date.now();
       isFirstTap = true;
       onDoubleTap = e => {
        const MIN_TIME_DELTA_BETWEEN_TAPS = 200; // in ms
        // eslint-disable-line no-return-assign consistent-return
        if (this.isFirstTap === 0) {
          this.isFirstTap = false;
          return;
        }
        const now = Date.now();
        const tapDelta = now - this.lastTappedTimestamp;
        // const msg = `On double Click ${tapDelta}, times ${this.d}`
        // this.setState({ onDblTap: msg });
        if (tapDelta < MIN_TIME_DELTA_BETWEEN_TAPS) {
          // this.setState({ onDblTap: 'prevented ' + msg });
          e.preventDefault();
          e.target.click();
        }
        this.lastTappedTimestamp = now;
      };  */
    _defineProperty(_assertThisInitialized(_this), "keyBinding", function () {
      return 'do-nothing';
    });
    _defineProperty(_assertThisInitialized(_this), "handleReturn", function () {
      return NOT_HANDLED;
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyCommand", function () {
      return false;
    });
    var _this$props4 = _this.props,
      _textNotes = _this$props4.textNotes,
      auth = _this$props4.auth,
      textRef = _this$props4.textRef,
      formatMessage = _this$props4.intl.formatMessage,
      _lesson = _this$props4.lesson;
    var screenHeight = process.env.BROWSER ? window.screen.height : 0;
    _this.MIN_PAGE_Y_HIGHTLIGHT = isWidthUp('sm', _this.props.width) ? screenHeight - 300 : 0.7 * screenHeight;
    _this.updateTextNotesWithDebounce = _.debounce(_this.updateTextNotes, 500);
    _this.setStateDebounced = _.debounce(_this.setState, 600);
    _this.handleScrollEventOnMobileDebounced = _.debounce(_this.handleScrollEventOnMobile, 600);
    var _props$lesson = props.lesson,
      content = _props$lesson.content,
      sources = _props$lesson.sources;
    var newContent = convertImages({
      cloudfrontUrl: context.cloudfrontUrl
    })(content);
    var newSources = _.cloneDeep(sources);
    if (isLoggedIn(auth)) {
      _.each(_textNotes, function (_ref2) {
        var offset = _ref2.offset,
          length = _ref2.length,
          blockKey = _ref2.blockKey;
        var blockIndex = _.findIndex(content.blocks, {
          key: blockKey
        });
        if (blockIndex !== -1) {
          newContent.blocks[blockIndex].inlineStyleRanges.push({
            style: 'HIGHLIGHT',
            offset: offset,
            length: length
          });
        }
      });
    }
    _this.state = {
      contentScrolledPercent: 0,
      rerenderEditor: false
    };
    var _editorState = createEditorState(newContent, decorators);
    var convertedSourcesData = convertRichEditorContentToHtml(newSources, context.cloudfrontUrl);
    var editorStateContent = _editorState && _editorState.getCurrentContent();
    var imageContent = getImagesFromDraftJS(_.get(props, 'lesson.content'));
    var isTextExist = editorStateContent && editorStateContent.hasText() && !!editorStateContent.getPlainText().trim().length || !!_.get(imageContent, 'length');
    var showEmptyContentMessage = false;
    if (!isTextExist && _.get(_lesson, 'audios.length') && !_lesson.youtubeVideoUrl) {
      var _stateFromHTML = stateFromHTML(formatMessage(messages.emptyContentMessage)),
        blockMap = _stateFromHTML.blockMap;
      var newState = Modifier.replaceWithFragment(_editorState.getCurrentContent(), _editorState.getSelection(), blockMap);
      _editorState = EditorState.push(_editorState, newState, 'insert-fragment');
      showEmptyContentMessage = true;
    }
    _this.state.editorState = _editorState;
    _this.state.isSourcesExist = convertedSourcesData.isTextExist;
    _this.state.isTextExist = isTextExist;
    _this.state.sourcesHTML = convertedSourcesData.contentHTML;
    _this.state.showEmptyContentMessage = showEmptyContentMessage;
    textRef(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Text, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.querySelector('#lesson-content').scrollTop = 0;
      window.addEventListener('scroll', this.handleScrollEventOnMobileDebounced);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkAndUpdateHighlightBtnPosition();
      // const el = this.editor._editorNode.editorContainer;
      // this.editorElement =
      //   this.editorElement ||
      //   document.getElementsByClassName('md-RichEditor-root')[0];
      // if (this.editorElement) {
      //   console.log(this.editorElement);
      //   console.log(this.editorElement.innerHeight);
      //   console.log(this.editorElement.outerHeight);
      //   console.log(this.editorElement.height);
      //   this.editorElement.style.height = `${this.editorElement.clientHeight}px`;
      // }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScrollEventOnMobileDebounced);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        formatMessage = _this$props5.intl.formatMessage,
        contentTypeSwitchers = _this$props5.contentTypeSwitchers,
        updatingTextNotes = _this$props5.updatingTextNotes,
        isNotesShown = _this$props5.isNotesShown,
        loadingTextNotes = _this$props5.loadingTextNotes,
        auth = _this$props5.auth,
        courseId = _this$props5.course._id,
        className = _this$props5.className,
        offline = _this$props5.offline;
      var _this$state = this.state,
        editorState = _this$state.editorState,
        isSourcesExist = _this$state.isSourcesExist,
        sourcesHTML = _this$state.sourcesHTML,
        isTextExist = _this$state.isTextExist,
        showEmptyContentMessage = _this$state.showEmptyContentMessage;
      var inlineButtons = [{
        label: formatMessage(messages.highlightLabel),
        style: 'HIGHLIGHT'
      }];
      return /*#__PURE__*/React.createElement(LessonTextContent, {
        ref: function ref(e) {
          // eslint-disable-next-line react/no-unused-class-component-methods
          _this2.editor = e;
        },
        editorState: editorState,
        editorEnabled: !showEmptyContentMessage && !offline && isNotesShown && isLoggedIn(auth) && !updatingTextNotes && !loadingTextNotes && !!courseId && !isMobileUserAgent(),
        onEditorChange: this.onEditorChange,
        handleKeyCommand: this.handleKeyCommand,
        keyBindingFn: this.keyBinding,
        handleReturn: this.handleReturn,
        inlineButtons: inlineButtons,
        isTextExist: showEmptyContentMessage ? contentTypeSwitchers.audio === true : isTextExist,
        fullWidth: !contentTypeSwitchers.video || offline,
        className: className,
        onContentScroll: this.onContentScroll,
        onSelect: function onSelect() {
          return false;
        },
        onEditorDoubleClick: this.onEditorDoubleClick,
        key: "Lesson-content-".concat(this.state.rerenderEditor)
      }, /*#__PURE__*/_jsx(EmbeddedAttachments, {
        withVideo: !!contentTypeSwitchers.video
      }), /*#__PURE__*/_jsx(LessonSources, {
        s: s,
        headerTitle: formatMessage(messages.sourcesLabel),
        isSourcesExist: contentTypeSwitchers.text && isSourcesExist,
        sourcesHTML: sourcesHTML
      }, "sourcescontent"), /*#__PURE__*/_jsx(Attachments, {
        withVideo: !!contentTypeSwitchers.video
      }));
    }
  }]);
  return Text;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  textRef: function textRef() {
    return null;
  },
  className: ''
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class) || _class);
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    textRef: ref
  }));
});